import { implementsTKeys, strEnum } from "../../types";
import {IInstanceInfo} from "../app-manager";
import {TCIApplicationDeploymentNotification} from "./tci-app-deploy";
import {ITCIMetrics} from "./tci-app-metrics";

export const ITCIHybridAgentStatusType = strEnum(["healthy", "heartbeatLost"]);
export type ITCIHybridAgentStatusType = keyof typeof ITCIHybridAgentStatusType;


export interface ITCIHybridAgentList {
    id: string;
    name: string;
    status: ITCIHybridAgentStatusType;
    machine: string;
    version: string;
    gsbc: string;
    lastContact: number;
    lastStartup: number;
    tunnelAccessKey: string;
}

// tslint:disable-next-line:no-empty-interface
export interface ITCIHybridMetrics extends ITCIMetrics {
}

export interface ITCIHybridInstanceStatus {
    appId?: string;
    success?: boolean;
    notificationType?: TCIApplicationDeploymentNotification;
    id: string;
    hybridAppStatus: string;
    instances: number;
    desiredInstances: number;
    failedInstances: number;
    startingInstances: number;
    heartbeatLostInstances: number;
    instancesInfo: IInstanceInfo[];
}

export interface ITCIAgentStatusCategory {
    statusIcon: string;
    statusBackground: string;
}

export class TCIAgentStatusCategory implements ITCIAgentStatusCategory {
    public static HEALTHY = new TCIAgentStatusCategory("Running", "icon-ic_restarting", "running-status");
    public static HEARTBEATLOST = new TCIAgentStatusCategory("Heartbeat failed", "icon-ic_critical_error", "error-status");
    // public static UNKNOWN = new TCIAgentStatusCategory("Unknown", "icon-ic_warning_triangle", "warning-status"); // Not in use

    constructor(public statusText: string, public statusIcon: string, public statusBackground: string) { }

    getStatusText() {
        return this.statusText;
    }

    getStatusIcon() {
        return this.statusIcon;
    }

    getStatusBackground() {
        return this.statusBackground;
    }
}

export interface ITCIHybridAgentApps {
    agentId: string;
    agentName: string;
    apps: string[];
}

export interface ITCIIHybridAgentSpecList {
    specs: string[];
    id: string;
    error?: any;
}
